import { Coins, Trophy } from "lucide-react";
import { Podium } from "./GoldRainResults";

export function GoldRainPost({ g }) {
  return (
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-rose-900 via-rose-950 to-black p-5 border-2 border-amber-300/60 shadow-lg shadow-amber-200/40" data-testid="goldrain-post">
      <div className="gold-banner absolute inset-x-0 top-0 h-1.5" aria-hidden />
      <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.3em] text-amber-300 flex items-center justify-center gap-1.5"><Trophy className="w-3.5 h-3.5" /> Goldregen-Sieger</p>
      <h3 className="text-center font-display text-2xl font-black text-white mt-1">Herzlichen Glückwunsch!</h3>
      <div className="mt-5"><Podium top={g.top} /></div>
      <p className="mt-4 text-center text-xs font-semibold text-amber-100/90 flex items-center justify-center gap-1.5" data-testid="goldrain-post-stats">
        <Coins className="w-4 h-4 text-amber-300" /> {g.players} Mitspieler · {g.caught} Münzen gefangen
      </p>
      <p className="mt-1 text-center text-xs text-white/60">Gratuliert den Gewinnern unten in den Kommentaren 💛</p>
    </div>
  );
}
